// extracted by mini-css-extract-plugin
export default {"container":"About_container__QZIHx","row":"About_row__m0XC4","header":"About_header__9VY+i","about-me":"About_about-me__mBYRN","buttons":"About_buttons__32knD"};